import React from "react";

function WhyPolygonzkEVM() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>Why Choose Xeer for Polygon zkEVM Development?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  At Xeer Technology, our expert developers utilize Polygon
                  zkEVM to build resilient, scalable applications that align
                  with your business needs. With a deep understanding of
                  zero-knowledge proofs and Ethereum-compatible scaling, we
                  ensure seamless deployment, security, and interoperability
                  across networks.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default WhyPolygonzkEVM;
